// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByNodeId, LinkModel } from "@insite/client-framework/Store/Links/LinksSelectors";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import { MappedLink } from "@store/Overrides/Widgets/Header/MainNavigation";

export const linkMapper = (state: ApplicationState, link: LinkModel) => {
    let mappedLink: MappedLink | undefined;

    if (!link.fields.destination) {
        return;
    }

    const { type, value } = link.fields.destination;

    if (type === "Url") {
        const title = link.fields.overriddenTitle || "";

        mappedLink = {
            url: value,
            title,
            type,
            excludeFromNavigation: false,
            openInNewWindow: link.fields.openInNewWindow,
        };
    }

    if (type === "Page") {
        const readonlyPageLink = getPageLinkByNodeId(state, value);
        if (readonlyPageLink) {
            mappedLink = { ...readonlyPageLink };
            if (link.fields.overriddenTitle) {
                mappedLink.title = link.fields.overriddenTitle;
            }
            mappedLink.type = type;
            mappedLink.excludeFromNavigation = false;
            mappedLink.openInNewWindow = link.fields.openInNewWindow;
        }
    }

    return mappedLink;
};

export const megaMenuImagelinkMapper = (state: ApplicationState, megaMenuImageLink: LinkModel | undefined) => {
    if (megaMenuImageLink) {
        const megaMenuImageLinkArray = Object.entries(megaMenuImageLink).map(([key, value]) => ({
            key,
            value,
        }));

        const destination: LinkFieldValue = {
            type: megaMenuImageLinkArray[0]["value"] || "Url",
            value: megaMenuImageLinkArray[1]["value"] || "",
        };

        const mappedMegaMenuImageLink = {
            fields: {
                destination,
                overriddenTitle: "",
                openInNewWindow: false,
                linkType: "Link",
                title: "",
                numberOfColumns: 1,
                maxDepth: 1,
            },
        };

        const mappedLink = {
            type: "Url",
            value: linkMapper(state, mappedMegaMenuImageLink)?.url,
        };

        return mappedLink;
    }
};
